<script setup lang="ts">
    import type { FrontendFieldDefinition } from '@hmmh/storyblok-forms';
    import type { FormInputs } from '~/utils/formUtils';
    import SelectInput, { type SelectOption } from '~/components/shared/SelectInput.vue';
    import { isRequiredField } from './form-field-utils';

    const props = defineProps<{ field: FrontendFieldDefinition }>();

    const formInputs = inject<Ref<FormInputs>>('formInputs');

    const model = computed<string>({
        get: () => String(formInputs?.value[props.field.name]?.value ?? ''),
        set: (value) => {
            const input = formInputs?.value[props.field.name];
            if (!input) return;
            input.value = value;
        }
    });

    const options = computed<SelectOption[]>(() => [
        {
            label: props.field.placeholder || '—',
            value: '',
            disabled: true
        },
        ...(props.field.options ?? []).map((option) => ({
            label: option.value,
            value: option.key
        }))
    ]);

    const validationErrors = computed(() => formInputs?.value[props.field.name]?.errors ?? []);
</script>

<template>
    <SelectInput
        :id="field.name"
        v-model="model"
        :label="field.label"
        :options="options"
        :required="isRequiredField(field)"
        :validation-errors="validationErrors"
    />
</template>
